import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import {
  PaginatedOptions,
  PaginatedResults,
} from "@sdk/utils/paginated-results";
import { UserTracker } from "user-tracker";
import {
  iWAMarketingCampaign,
  iWAMarketingCampaignLog,
  iWAMarketingTemplate,
} from "./wa-marketing-campaigns-model";

export class WAMarketingCampaignsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.waMarketingCampaigns.configure(config);
  }

  waMarketingCampaigns = Object.assign(
    new EntityServices<iWAMarketingCampaign>(
      SDKConfig,
      "wa-marketing-campaigns",
      {
        onCreate: () => {
          UserTracker.track("WA MARKETING CAMPAIGNS - Create", {});
        },
        onDelete: () => {
          UserTracker.track("WA MARKETING CAMPAIGNS - Delete", {});
        },
      },
    ),
    {
      sendCampaign: async (campaignId: string) => {
        UserTracker.track("WA MARKETING CAMPAIGNS - Send", {});
        const results: AxiosResponse<iWAMarketingCampaign> = await axios.post(
          this.config.basePath + `/wa-marketing-campaigns/${campaignId}/send`,
          {},
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      sendTest: async (campaignId: string, phone: string) => {
        UserTracker.track("WA MARKETING CAMPAIGNS - Send Test", {});
        const results: AxiosResponse<{ status: boolean; wamid?: string }> =
          await axios.post(
            this.config.basePath +
              `/wa-marketing-campaigns/${campaignId}/send-test`,
            { phone },
            {
              headers: {
                Authorization: this.config.token,
              },
            },
          );
        return results.data;
      },
      queryLogs: async (
        campaignId: string,
        req: { query: any; options: PaginatedOptions },
      ) => {
        const results: AxiosResponse<
          PaginatedResults<iWAMarketingCampaignLog>
        > = await axios.post(
          this.config.basePath +
            `/wa-marketing-campaigns/${campaignId}/logs/query`,
          req,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      queryReport: async (campaignId: string, req: { query: any }) => {
        const results: AxiosResponse<{ count: number }> = await axios.post(
          this.config.basePath +
            `/wa-marketing-campaigns/${campaignId}/report`,
          req,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      listTemplates: async (connectionId: string) => {
        const results: AxiosResponse<iWAMarketingTemplate[]> = await axios.get(
          this.config.basePath +
            `/wa-marketing-campaigns/connections/${connectionId}/templates`,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
    },
  );
}
